import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { ArrowBack } from '@one-thd/sui-icons';
import THDStorageUtils, { SESSION_STORAGE, } from '@thd-olt-global/thd-storage-utils';
import { useExperienceContext } from '../../../hooks/useContexts';
/* only renders on the order details page and does not render if the session storage does not have a value for the order-project-id */
export var BackToProjectLink = function () {
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var navigate = useNavigate();
    var _a = useState(''), orderProjectId = _a[0], setOrderProjectId = _a[1];
    var fetchOrderProjectId = function () {
        var projectId;
        try {
            projectId = THDStorageUtils.get(SESSION_STORAGE, {
                key: 'order-project-id',
            });
            // eslint-disable-next-line no-empty
        }
        catch (error) { }
        if (!projectId || projectId === 'undefined')
            return '';
        THDStorageUtils.remove(SESSION_STORAGE, { key: 'order-project-id' });
        return projectId;
    };
    useEffect(function () {
        setOrderProjectId(fetchOrderProjectId());
    }, []);
    var handleBackToProjectLinkClick = function () {
        THDStorageUtils.set(SESSION_STORAGE, {
            key: 'projects-active-tab',
            value: 'purchases',
        });
        navigate("/projects/".concat(orderProjectId));
    };
    if (orderProjectId && !isConsumerApp) {
        return (React.createElement(Link, { underline: "always", onClick: handleBackToProjectLinkClick, "data-testid": "back-to-project-link" },
            React.createElement("div", { className: "sui-flex sui-flex-row sui-items-center sui-gap-2 sui-pt-4" },
                React.createElement(ArrowBack, { size: "small" }),
                React.createElement(Typography, null, "Back to Project"))));
    }
    return null;
};
